module.exports = __webpack_public_path__ + "img/remove_icon.eeb20e85.svg";